// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dde0dfdb","455":"6d49da01","977":"4a5192a9"}[chunkId] + ".chunk.js";
};